import React, { HTMLAttributes, useMemo } from "react";
import cx from "classnames";
// import { Hooks } from "@xt/xtbase";
// const { useTranslation } = Hooks;
// import store from "store";
import ItemButton, { VerifyTypeEnum } from "../ItemButton";

import styles from "./index.module.scss";
import { FaItemProps } from "../Modal";

interface Props extends HTMLAttributes<HTMLDivElement> {
  skipMode?: VerifyTypeEnum;
  isPasskey: boolean;
  faItems: FaItemProps[];
  clickFun: (arg: VerifyTypeEnum) => void;
}

const ValidateItemAry = [VerifyTypeEnum.email, VerifyTypeEnum.mobile, VerifyTypeEnum.google];

const Main: React.FC<Props> = ({ skipMode, isPasskey, faItems, clickFun, className }) => {
  // const t = useTranslation();
  // const {isLogin} = store.user;

  const typeAry = useMemo(() => {
    const ary: VerifyTypeEnum[] = [];
    isPasskey && skipMode !== VerifyTypeEnum.passkey && ary.push(VerifyTypeEnum.passkey);
    faItems.map(({ validateItemType }) => {
      ValidateItemAry[validateItemType] !== skipMode && ary.push(ValidateItemAry[validateItemType]);
    });
    return ary;
  }, [skipMode, isPasskey, faItems]);

  return (
    <div className={cx(styles.main, className)}>
      {typeAry.map((type) => (
        <ItemButton key={type} type={type} onClick={() => clickFun(type)} />
      ))}
    </div>
  );
};

export default Main;
